import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export function useIsInView(
  ref: RefObject<HTMLElement | null>,
  threshold: number,
) {
  const isInView = useRef(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        isInView.current = entry.isIntersecting;
      },
      {
        root: null,
        rootMargin: '0px',
        threshold,
      },
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, threshold]);

  return isInView;
}
